<template>
    <div id="schoolSignupNoticeDetail" class="page">
        <div class="second-header-wrap">
            <el-button @click="$router.back()" size="medium">返回</el-button>
            <el-button type="primary" @click.native="jumpToPage('noticeEdit', {id})" v-if="isSelectedYearCurrent" size="medium">编辑</el-button>
            <el-button type="primary" v-if="status === 1 && isSelectedYearCurrent" @click.native="publishHandler" size="medium">发布</el-button>
        </div>
        <div class="main-container">
            <h1>{{title}}</h1>
            <div class="main-container__sub">
                <div class="create-user">{{createUserName}}&nbsp;&nbsp;{{createTime | timeSuffixFilter}}</div>

            </div>
            <div>
                <image-previewer tag="richtext" >
                    <div class="content" v-html="recruitDesc"></div>
                </image-previewer>
            </div>
        </div>
        <div class="detail-info">
            <div class="detail-info__title">招生信息</div>
            <div class="signup-info">
                <span class="signup-info__label">招生登记日期：</span>
                <span class="signup-info__value">{{startDate | secondTimeFilter}}——{{endDate | secondTimeFilter}}</span>
            </div>
            <div class="signup-info">
                <span class="signup-info__label">出生日期限制：</span>
                <span class="signup-info__value">{{minBirthday}}——{{maxBirthday}}</span>
            </div>
            <div class="signup-info">
                <span class="signup-info__label">招生人数：</span>
                <span class="signup-info__value">{{maxRecruitCount}}</span>
            </div>
            <div class="signup-info">
                <span class="signup-info__label">招生登记模板：</span>
                <span class="signup-info__value">{{templateName}}</span>
            </div>
            <div class="url-section">
                <div class="signup-info">
                    <span class="signup-info__label">pc端招生登记链接：</span>
                    <span class="signup-info__value">{{pcUrl}}</span>
                </div>
                <div class="signup-info">
                    <span class="signup-info__label">移动端招生登记链接：</span>
                    <span class="signup-info__value">{{mobileUrl}}</span>
                </div>
                <div class="qrcode-container">
                    <img :src="qrcodeUrl" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcode'
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer';
    import {getVoteTwoTempList} from '@/api/setting';

    import {
        updateVoteTwoRecruitNotice,
        getVoteTwoRecruitNotice
    } from '@/api/notice';
    import baseMixin from '@/mixins/baseMixin';
    import {mapGetters} from 'vuex';


    export default {
        name: "NoticeDetail",
        data() {
            return {
                id: this.$route.query.id,
                title: '',
                recruitDesc: '',
                startDate: '',
                endDate: '',
                voteId: '',
                createUserName: '',
                createTime: '',
                status: 1,
                cover: '',
                templateName: '',
                qrcodeUrl: '',
                pcUrl: '',
                mobileUrl: '',
                schoolId: '',
                ageRange: [],
                maxRecruitCount: 1,
                minBirthday: '',
                maxBirthday: ''
            }
        },
        computed: {
            ...mapGetters(['isSelectedYearCurrent'])
        },
        components: {ImagePreviewer},
        mixins: [baseMixin],
        filters: {
            secondTimeFilter(value) {
                return value.substring(0, 16);
            }
        },
        created() {
            getVoteTwoRecruitNotice({
                noticeId: this.id
            })
                .then(res => res.data)
                .then(data => {
                    if(data.result) {
                        const pageData = data.data;
                        this.title = pageData.title;
                        this.recruitDesc = pageData.recruitDesc;
                        this.startDate = pageData.startDate;
                        this.endDate = pageData.endDate;
                        this.voteId = pageData.voteId;
                        this.createUserName = pageData.createUserName;
                        this.createTime = pageData.createTime;
                        this.status = pageData.status;
                        this.cover = pageData.cover;
                        this.schoolId = pageData.schoolId;
                        this.maxRecruitCount = pageData.maxRecruitCount;
                        this.minBirthday = pageData.minBirthday;
                        this.maxBirthday = pageData.maxBirthday;

                        getVoteTwoTempList({
                            voteTitle: ''
                        })
                            .then(res => res.data)
                            .then(data => {
                                this.templateName = data.data.find(({id}) => id === this.voteId).voteTitle;
                            });
                        console.log('this.basePath', this.basePath)
                        const baseHref = this.basePath.indexOf('xwweixiao.com') !== -1 || this.basePath.indexOf('localhost') !== -1 || this.basePath.indexOf('weixiaojia.net') !== -1 ? 'https://www.weixiaojia.net/mobile/#/' : 'https://m.www.weixiaojia.cn/mobile/#/';

                        QRCode.toDataURL(`${baseHref}SchoolSignup/notice?id=${this.id}&schoolId=${pageData.schoolId}`)
                            .then(url => {
                                this.qrcodeUrl = url;
                            })
                            .catch(err => {
                            });

                        this.mobileUrl = `${baseHref}SchoolSignup/notice?id=${this.id}&schoolId=${pageData.schoolId}`;
                        this.pcUrl = this.basePath.indexOf('xwweixiao.com') !== -1 || this.basePath.indexOf('localhost') !== -1 || this.basePath.indexOf('weixiaojia.net') !== -1 ? `https://www.weixiaojia.net/schoolSignup/#/kindergarten/outer/outerNotice?id=${this.id}&schoolId=${pageData.schoolId}` : `http://www.zhxiaoyuan.cn/schoolSignup/#/kindergarten/outer/outerNotice?id=${this.id}&schoolId=${pageData.schoolId}`;
                    }
                })
        },
        methods: {
            publishHandler() {
                const args = {};

                args.id = this.id;
                args.cover = this.cover;
                args.recruitDesc = this.recruitDesc;
                args.status = 2;
                args.title = this.title;
                args.voteId = this.voteId;
                args.startDate = this.startDate;
                args.endDate = this.endDate;
                args.minBirthday = this.minBirthday;
                args.maxBirthday = this.maxBirthday;
                args.maxRecruitCount = this.maxRecruitCount;

                this.$confirm('是否确认发布?', '发布', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateVoteTwoRecruitNotice(args)
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                const _this = this;
                                this.$message({
                                    message: '发布公告成功',
                                    type: 'success',
                                    onClose: function () {
                                        _this.$router.back();
                                    }
                                });
                            }
                        });
                }).catch(() => {
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";
    .detail-info {
        margin: 10px auto;
        width: 600px;
        border: 1px solid #E3E3E3;
        .detail-info__title {
            background-color: #F7F7F7;
            text-align: center;
            padding: 10px;
            font-weight: bold;
        }
    }
    .signup-info {
        box-sizing: border-box;
        width: 550px;
        margin: 10px auto;
        font-size: 16px;
        color: #606266;
    }
    .signup-info__value {
        color: #20A0FF;
        word-break: break-all;
    }
    .qrcode-container {
        text-align: center;
    }
    .detail-info__url {
        font-size: 14px;
    }
    .page {
        padding: 15px;
    }
    .main-container {
        width: 810px;
        margin: 10px auto;
        .main-container__sub {
            margin: 0 auto;
        }
        h1 {
            text-align: center;
            margin: 10px 0;
        }
        .content {
            width: 80%;
            margin: 0 auto;
            @include richtext;
            min-height: 200px;
            color: #555;
            line-height: 1.2em;
        }
        .create-user {
            font-size: 14px;
            color: #999;
            text-align: center;
            margin: 10px 0;
        }

    }
    .section-title {
        border-left: 4px solid #409eff;
        padding-left: 8px;
        margin: 12px 0 8px 0;
    }
    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
</style>
<style lang="scss">
    @import "../../../styles/mixin.scss";
    #schoolSignupNoticeDetail {
        .content {
            width: 80%;
            margin: 0 auto;
            @include richtext;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/kindergarten/notice/NoticeDetail.vue